const validURL = (str: string) => {
	const pattern = new RegExp('^((ft|htt)ps?:\\/\\/)?' +
		'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
		'((\\d{1,3}\\.){3}\\d{1,3}))' +
		'(\\:\\d+)?' +
		'(\\/[-a-z\\d%@_.~+&:]*)*' +
		'(\\?[;&a-z\\d%@_.,~+&:=-]*)?' +
		'(\\#[-a-z\\d_]*)?$', 'i');
	return pattern.test(str);
};
export const isWebsiteUrlValid = (string: string) => {
	if (!string) { return; };
	try {
		if (string.includes('http://')) {
			string = string.replace('http://', 'https://');
		} else if (!string.includes('https://')) {
			string = 'https://' + string;
		}
		if (!validURL(string)) {
			return;
		}
		return new URL(string);
	} catch (error) {
		return;
	}
};